import { useQuery } from '@hooks/reactQuery';

import { portalFiles, portalFolders as portalFoldersSelector } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getPortalFiles } from '@api/portalFiles';

import { extractQueryParams } from '@utils/common';

import { IItemsResponse } from '@interfaces/common/response';
import { IPortalFileDTO } from '@interfaces/portal/dto/foldersManagementDTO';

import { GET_PORTAL_FILES } from '@constants/queryKeys';

interface IUseQueryPortalFilesReturned {
	isLoadingPortalFiles: boolean;
	countOfRecords: number;
	portalFiles: Array<IPortalFileDTO>;
}

export const useQueryPortalFiles = (): IUseQueryPortalFilesReturned => {
	const {
		page,
		pageSize,
		searchValue,
		sortFieldName,
		sortDirection,
		folderId,
	} = useAppSelector(portalFiles);

	const {
		searchValue: globalSearchValue,
		milestones,
	} = useAppSelector(portalFoldersSelector);

	const {
		data,
		isInitialLoading,
	} = useQuery<IItemsResponse<IPortalFileDTO>>({
			queryKey: [
				GET_PORTAL_FILES,
				{
					page,
					pageSize,
					searchValue: globalSearchValue || searchValue,
					sortFieldName,
					sortDirection,
					folderId,
					milestoneIds: milestones,
				},
			],
			queryFn: extractQueryParams(getPortalFiles),
			enabled: [!!folderId],
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
			refetchOnMount: true,
			staleTime: 0,
		},
	);

	return {
		isLoadingPortalFiles: isInitialLoading,
		portalFiles: data?.items || [],
		countOfRecords: data?.count || 0,
	};
};
